import i18next from 'i18next';

i18next.addResources('en', 'NewMashModal', {
  title: 'Record new mash',
  selectPeriod: 'Select a period',
  periodId: 'Period ID',
  mashingId: 'Mash ID',
  milledDate: 'Milled date',
  mashDate: 'Mash date',
  note: 'Notes',
  confirm: 'Confirm'
});
